import { Container, Reveal, RevealGroup } from '@/components/common'
import { areas } from '@/constants/impact-areas'

export const ImpactAreas = () => {
  return (
    <section className="bg-surface py-24 lg:py-32">
      <Container>
        <div className="max-w-3xl">
          <Reveal variant="up" delay={100}>
            <h2 className="mt-7 text-4xl font-bold leading-[1.05] tracking-[-0.02em] text-ibon-dark sm:text-5xl lg:text-6xl">
              Where our work <span className="text-ibon-dark/30">makes a difference.</span>
            </h2>
          </Reveal>
        </div>

        <RevealGroup
          className="mt-16 grid gap-px overflow-hidden border border-border bg-border sm:grid-cols-2 lg:grid-cols-3"
          step={90}
        >
          {areas.map(({ title, description, Icon }) => (
            <article
              key={title}
              className="group flex flex-col bg-white p-8 transition-colors hover:bg-ibon-dark lg:p-10"
            >
              <Icon className="text-4xl text-ibon-sky" />
              <h3 className="mt-8 text-2xl font-bold tracking-tight text-ibon-dark transition-colors duration-300 group-hover:text-white">
                {title}
              </h3>
              <p className="mt-4 text-base leading-relaxed text-text-muted transition-colors duration-300 group-hover:text-white/70">
                {description}
              </p>
            </article>
          ))}
        </RevealGroup>
      </Container>
    </section>
  )
}
